import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { PriceOfferCreatePayload } from 'api/actions/price-offer-create/price-offer-create-payload';
import { PriceOfferCreatePathParameters } from 'api/actions/price-offer-create/price-offer-create-path-parameters';
import { PriceOfferCreateResponse } from 'api/actions/price-offer-create/price-offer-create-response';

type PriceOfferCreateQueryParameters = Record<string, any>;

/**
 * The path of the PriceOfferCreate action.
 */
export const priceOfferCreateActionPath = new SweetPath<keyof PriceOfferCreatePathParameters>(
  '/api/price-offer/create',
  { path: '{param}' }
);

/**
 * Creates a contextualized PriceOfferCreate actions.
 */
export default function createPriceOfferCreateAction(axios: AxiosInstance) {
  return function priceOfferCreateAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: PriceOfferCreateQueryParameters;
    payload: PriceOfferCreatePayload;
  }) {
    const path = priceOfferCreateActionPath.original;

    return axios.request<PriceOfferCreateResponse, PriceOfferCreateResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
